import React from "react";
import MainImg from "../../../Assets/About/about1.png";
import { Phone, Mail } from "lucide-react";

export default function MiningHero() {
  return (
    <div className="bg-white min-h-screen px-4 sm:px-8 py-12">
      {/* Main Section */}
      <div className="max-w-7xl mx-auto ">
        <div className="flex flex-col lg:flex-row gap-12 items-start">
          {/* Left: Image */}
          <div className="w-full lg:w-[47%] flex-shrink-0">
            <div className="relative rounded-xl overflow-hidden shadow-lg aspect-[4/3]">
              <img
                src={MainImg}
                alt="Open pit mining aerial view"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src =
                    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80";
                }}
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="flex-1 flex flex-col justify-between">
            {/* Label */}
            <div>
              <span className="text-[10px] sm:text-xs md:text-sm font-krona font-bold tracking-[0.22em] text-gray-700 uppercase border-b-2 border-[#e8341c] pb-1 inline-block">
                WHO WE ARE
              </span>
              <h2 className="mt-2 sm:mt-5 text-gray-900 font-bold font-krona text-2xl  tracking-wider leading-snug">
                <span className="block">
                  We are a team of mining professionals performing a full
                  spectrum of mining services.
                </span>
                <span className="block mt-2 sm:mt-3">
                  {" "}
                  We perform contract mining services for our partners across
                  India.
                </span>
              </h2>

              {/* Divider */}
              <hr className="border-gray-200 my-6" />
            </div>

            {/* Core Strengths Section */}
            <div className="">
              <div className="flex items-center justify-between mb-5">
                <span className="font-bold text-gray-800 text-sm">
                  Our Core Strengths
                </span>
                <span className="text-xs text-gray-400">
                  Delivering excellence in mining operations
                </span>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {[
                  {
                    title: "Safety First",
                    desc: "Strict safety standards in every project",
                  },
                  {
                    title: "Advanced Equipment",
                    desc: "Modern machinery & technology",
                  },
                  {
                    title: "Expert Team",
                    desc: "Highly skilled mining professionals",
                  },
                  {
                    title: "Pan India",
                    desc: "Operations across multiple states",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-gray-50 hover:bg-red-50 transition-all duration-300 rounded-lg p-4 shadow-sm hover:shadow-md cursor-pointer"
                  >
                    <h4 className="text-sm font-bold text-gray-900 mb-1">
                      {item.title}
                    </h4>
                    <p className="text-xs text-gray-500 leading-snug">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <hr className="border-gray-200 mx-6" />

      {/* Contact Bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-7">
        <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 lg:gap-12 xl:gap-16 items-center sm:items-start justify-center">
          {/* Phone */}
          <div className="flex items-center gap-3 sm:gap-4 w-full sm:w-auto justify-center sm:justify-start">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0">
              <Phone
                className="w-4 h-4 sm:w-5 sm:h-5 text-white"
                fill="white"
              />
            </div>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:gap-4 items-center sm:items-start">
              <p className="text-[8px] sm:text-[10px] md:text-xs lg:text-sm font-semibold tracking-widest text-gray-400 uppercase leading-tight text-center sm:text-left">
                Call Us
                <br className="hidden sm:block" />
                Directly
              </p>
              <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-black text-gray-900 tracking-tight break-all text-center sm:text-left">
                +91 977 777 4005
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-center gap-3 sm:gap-4 w-full sm:w-auto justify-center sm:justify-start">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0">
              <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            </div>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:gap-4 items-center sm:items-start">
              <p className="text-[8px] sm:text-[10px] md:text-xs lg:text-sm font-semibold tracking-widest text-gray-400 uppercase leading-tight text-center sm:text-left">
                E-Mail Us
                <br className="hidden sm:block" />
                Directly
              </p>
              <p
                className="text-sm sm:text-base md:text-xl lg:text-2xl font-black text-gray-900 tracking-tight underline decoration-gray-800 break-all text-center sm:text-left"
                style={{ textUnderlineOffset: "3px" }}
              >
                headoffice@prudenceindia.com
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Divider */}
      <hr className="border-gray-200 mx-6" />
    </div>
  );
}
